import { Controller } from '@hotwired/stimulus';
import { UnsavedChangesGuard } from '../lib/unsaved_changes_guard.js';

// Only the modal wrapper owns submission and discard confirmation.
export default class extends Controller {
  static values = { message: String };

  connect() {
    this.modalFrame = this.element.closest('dialog')?.closest('turbo-frame');
    this.closing = event => this.guard?.confirmModalClose(event);
    this.start = () => { this.element.inert = true; };
    this.end = event => {
      this.element.inert = false;
      if (event.detail.success) this.guard?.submitSucceeded(this.snapshot);
    };
    this.modalFrame?.addEventListener('modal:closing', this.closing);
    this.element.addEventListener('turbo:submit-start', this.start);
    this.element.addEventListener('turbo:submit-end', this.end);
  }

  changed(event) {
    this.guard ||= new UnsavedChangesGuard(this, event.detail.baseline);
    this.snapshot = event.detail.snapshot;
    this.guard.update(this.snapshot);
  }

  confirmClick(event) { this.guard?.confirmClick(event); }
  confirmVisit(event) { this.guard?.confirmVisit(event); }
  confirmUnload(event) { this.guard?.confirmUnload(event); }
  confirmHistory(event) { this.guard?.confirmHistory(event); }

  disconnect() {
    this.modalFrame?.removeEventListener('modal:closing', this.closing);
    this.element.removeEventListener('turbo:submit-start', this.start);
    this.element.removeEventListener('turbo:submit-end', this.end);
    this.guard?.disconnect();
  }
}
